import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=7554eae4&"
import script from "./FaqCard.vue?vue&type=script&lang=js&"
export * from "./FaqCard.vue?vue&type=script&lang=js&"
import style0 from "./FaqCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports